import bffClient, { GetDistributionOverviewMarketResponse } from '_clients/BFFClient';
import { isAbortError } from '_shared/helpers/errorHelper';
import useMarketStore from '_stores/market';
import { useEffect, useRef, useState } from 'react';

const ongoingCalls = {};

export type useNetworkMarketsDataType = {
  networkMarkets: GetDistributionOverviewMarketResponse[]
  isLoading :boolean
}
const useNetworkMarketsData = (networkId, contractId) => {

  const { networkMarkets, setNetworkMarkets } = useMarketStore();
  const [isLoading, setIsLoading] = useState(true);
  const abortController = useRef(null);
  const oneMinuteInMilliseconds = 60000;
  

  useEffect(() => {
    const loadOverview = async (networkId, contractId) => {
      const callId = `${networkId}-${contractId}`;
      if (abortController.current) {
        abortController.current.abort();
      }

      if (networkMarkets.creationDate > new Date(Date.now() - oneMinuteInMilliseconds)) {
        if(networkId && networkMarkets.networkId == networkId
          || contractId && networkMarkets.markets.some(e => e.products.some(p => p.contracts.some(c => c.contractId === Number(contractId))))
          || !networkId && !contractId && networkMarkets && !networkMarkets.networkId) {
            setIsLoading(false);
            return;
        }
      }
      setIsLoading(true);

      try {
        if(!ongoingCalls[callId]) {
          abortController.current = new AbortController();
          ongoingCalls[callId] = abortController.current;

          const call = networkId
              ? bffClient.getNetworkDistributionOverview(networkId, undefined, abortController.current.signal)
              : bffClient.getMultiBeneficiariesDistributionOverview(undefined, abortController.current.signal);

          const response = await call;
          setNetworkMarkets(response.result.markets, networkId, contractId);
        }
        setIsLoading(false);
        delete ongoingCalls[callId];
      } catch (error) {
        delete ongoingCalls[callId];
        if (isAbortError(error)) {
          console.warn('Fetch aborted: Loading overview', error);
        } else {
          setIsLoading(false);
          console.log("Error loading overview", error);
        }
      }
    };
    loadOverview(networkId, contractId);
  }, [networkId, contractId]);

  return { networkMarkets: networkMarkets.markets, isLoading } as useNetworkMarketsDataType

};

export default useNetworkMarketsData;